import { BaseHandler } from "../../../infrastructure/base-handlers";
import { resetFilters } from "./actions";
import { ResetFiltersCommand } from "./request";

export class ResetFiltersHandler extends BaseHandler {
  async handle(request: ResetFiltersCommand) {
    try {
      this.api.broker.publish(this.api.broker.events.activityHistory.filtersCleaned);
      this.store.dispatch(resetFilters());
    } catch (e) {
      console.error(e.message);
    }
  }
}
